import script from "./IndustryExpertiseStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndustryExpertiseStep.vue?vue&type=script&setup=true&lang=ts"

import "./IndustryExpertiseStep.vue?vue&type=style&index=0&id=aade37f0&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aade37f0"]])

export default __exports__